import React from 'react';
import { ImageBackground, ViewStyle } from 'react-native';
import { withTheme } from 'Theme';
import defaultStyles from './styles';

const defaultBackgroundImage: {
    uri: string;
    // eslint-disable-next-line @typescript-eslint/no-var-requires
} = require('../../../../platformAssets/runtime/images/bg.png');

interface BackgroundProps {
    style?: ViewStyle;
    theme?: { backgroundImageUri: string };
    children?: React.ReactNode;
    customImage?: string;
}
const Background = ({
    children,
    style = {},
    theme,
    customImage
}: BackgroundProps): React.ReactElement => {
    const defaultSource: { uri: string } = theme?.backgroundImageUri
        ? { uri: theme.backgroundImageUri }
        : defaultBackgroundImage;

    const source = customImage ? { uri: customImage } : defaultSource;

    return (
        <ImageBackground
            source={source}
            // defaultSource={source}
            style={[defaultStyles.backgroundImage, style]}>
            {children}
        </ImageBackground>
    );
};

export default withTheme(Background);
